module.exports = __webpack_public_path__ + "static/media/radiaant_logo.bd32bbd7.svg";